import { render, staticRenderFns } from "./NewFolderModal.vue?vue&type=template&id=50cc3bad&"
import script from "./NewFolderModal.vue?vue&type=script&lang=js&"
export * from "./NewFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./NewFolderModal.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports